module.exports = __webpack_public_path__ + "20250721160708/img/activity.55cccb0a.png";